import axios from 'axios';

export const initialState = {
  activeMenuItem: 'Aussehen',
  layout: {
    colors: {
      primary: '',
      navBar: '',
    },
    images: {
      logo: '',
      hero: ''
    },
    contact: {
      companyName: '',
      address: {},
      email: '',
      phone: '',
      openingHours: {},
    },
    text: {
      logo: '',
      heroTitle: 'Herzlich willkommen!',
      heroSubtitle: 'Bringen Sie den Spaß am Fahren zurück. Wir arbeiten daran!',
    }
  }
};

export const mutations = {
  SET_MENU_ITEM (state, newValue) {
    state.activeMenuItem = newValue;
  },
  SET_LAYOUT (state, newValue) {
    state.layout = newValue;
  },
  RESET (state) {
    Object.keys(state).forEach((attr) => { state[attr] = initialState[attr]; });
  },
};

export const actions = {
  setMenuItem ({ commit }, item) {
    commit('SET_MENU_ITEM', item);
  },

  async getLayout ({ commit }) {
    const { data } = await axios.get('/layout');
    commit('SET_LAYOUT', data.data);
  },

  async updateLayout ({ state }) {
    return axios.put('/layout', state.layout);
  }

};


export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations,
};
